import { useState, useRef, useEffect } from "react";

const EMOJI_LIST = [
  "😊", "😂", "🤣", "❤️", "🔥", "👍", "👏", "🙌", "💪", "🎉",
  "✨", "🌟", "😍", "🥰", "😘", "🤗", "😎", "🤔", "😅", "😭",
  "🥺", "😤", "💯", "⭐", "🏆", "🎯", "📝", "💡", "🌱", "🚀",
  "🙏", "👋", "✌️", "🤝", "❓", "💬", "📌", "🔔", "⏰", "☕",
];

export default function EmojiPicker({ onSelect }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    if (open) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  return (
    <div className="emoji-picker-wrapper" ref={ref}>
      <button
        type="button"
        className="emoji-picker-trigger"
        onClick={() => setOpen(!open)}
        title="Chọn emoji"
      >
        😊
      </button>
      {open && (
        <div className="emoji-picker-popup">
          {EMOJI_LIST.map(emoji => (
            <button
              key={emoji}
              type="button"
              className="emoji-picker-item"
              onClick={() => { onSelect(emoji); setOpen(false); }}
            >
              {emoji}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
